<script setup lang="ts">
import { computed } from 'vue';
import useNavigationStore from '../../stores/navigation';
import useLocale from '../../composables/useLocale';
import type { GoToItem } from '../../types';
import { flattenToc } from '../../util/navigation/toc-utils';
import TableOfContentsItem from './TableOfContentsItem.vue';

type Emits = {
  (e: 'goToContent', item: GoToItem): void;
};
const emit = defineEmits<Emits>();

type Props = {
  search: string;
};
const props = defineProps<Props>();

const { t } = useLocale();
const { findInNavigation } = useNavigationStore();

const filteredItems = computed(() => {
  return flattenToc(findInNavigation(props.search, false));
});
</script>

<template>
  <v-sheet data-testid="bp-toc-tab">
    <v-list v-if="filteredItems.length">
      <v-virtual-scroll :items="filteredItems" renderless>
        <template #default="{ item, itemRef }">
          <TableOfContentsItem :ref="itemRef" :item="item" @goToContent="emit('goToContent', $event)" />
        </template>
      </v-virtual-scroll>
    </v-list>
    <p v-else class="text-center pa-4">
      {{ t('book_player.message_no_toc_items') }}
    </p>
  </v-sheet>
</template>
